ACC.uploadcart = {

    _autoload: [
        "bindPopupChoose",
        "bindPopupUpload",
        ["changeForm", $(window).width() > 640],
	],

    bindPopupChoose: function () {
        $(document).on("click",".js-upload-cart",function(e){
            e.preventDefault();
            ACC.uploadcart.popupChoose();
		});
        
    },

    popupChoose: function () {

        ACC.colorbox.open("", {
            href: "#upload-btns",
            inline: true,
            width: "500px",
            height: "400px",
            className: "popup-choose",
            onComplete: function () {
                $(".js-btn-cancel").on("click", function (e) {
                    e.preventDefault();
                    ACC.colorbox.close();
                    $.colorbox.resize();
                });

                $(".js-btn-merge").on("click", function (e) {
                    e.preventDefault();
                    if ($(window).width() < 640){
                        ACC.uploadcart.popupUploadMobile("true");
                    }else {
                        ACC.uploadcart.popupUpload("true");
                    }
                });

                $(".js-btn-replace").on("click", function (e) {
                    e.preventDefault();
                    if ($(window).width() < 640){
                        ACC.uploadcart.popupUploadMobile("false");
                    }else {
                        ACC.uploadcart.popupUpload("false");
                    }
                });


            },
            onClosed: function () {
                $("#upload-btns").load(location.href + " #upload-btns");
            }
        });
    },

    bindPopupUpload: function () {
        $(document).on("click",".js-upload-popup",function(e){
            e.preventDefault();
            if ($(window).width() < 640){
                ACC.uploadcart.popupUploadMobile();
            }else {
                ACC.uploadcart.popupUpload();
            }
		});

        $(".w-upload-form .upload-submit").on("click",function (e) {
            e.preventDefault();
            $(".w-upload-form .upload-submit").attr("disabled", true); 
            ACC.uploadcart.uploadForm();
        });
    },

    popupUploadMobile: function (type) {
        var $fileInput = $('.w-upload-form .file-input');

        $(".w-upload-form .js-type-effect").val(type);
        $('.w-upload-form .file-input').click();
        // change inner text
        $fileInput.on('change', function() {
            $('.w-upload-form .wrapper-errors').addClass("hidden");
            $('.w-upload-form .wrapper-drop').removeClass("hidden");
            $('.w-upload-form .textError').removeClass("visible");
            $('.w-upload-form .w-upload-form').removeClass("height-sm").removeClass("clean-popup");

            var $fileval = $fileInput.val();
            var filesCount = $(this)[0].files.length;
            var $textContainer = $(this).prev();
            var maxSizeMb = 1;

            if (filesCount == 1) {
                // if single file is selected, show file name
                // Allowing file type
                var fileSelected = $(this)[0].files[0];
                var allowedExtensions = /(\.csv|\.xls|\.xlsx)$/i;
                //Get the size of the input file.
                var totalSize = fileSelected.size;

                //Convert bytes into MB.
                var totalSizeMb = totalSize  / Math.pow(1024,2);
                if (!allowedExtensions.exec($fileval)) {
                    $('.w-upload-form .wrapper-errors').removeClass("hidden");
                    $('.w-upload-form .textError').removeClass("visible");
                    $('.w-upload-form .format-error').addClass("visible");
                    $fileInput.val("");
                    $('.w-upload-form .wrapper-drop').addClass("hidden");
                    $('.w-upload-form .w-upload-form').addClass("height-sm");
                    ACC.colorbox.open("", {
                        href: "#upload-form",
                        inline: true,
                        width: "500px",
                        height: "400px",
                        className: "popup-upload",
                        onComplete: function () {
                            $.colorbox.resize();
                        },
                        onClosed: function () {
                            $("#upload-form").load(location.href + " .form-upload-file-cart");
                        }
                    });
                    return false;
                } else if (totalSizeMb > maxSizeMb){ 
                    //Create an error message to show to the user.
                    // var errorMsg = 'File too large. Maximum file size is ' + maxSizeMb + 'MB. Selected file is ' + totalSizeMb.toFixed(2) + 'MB';
                    $fileInput.val("");
                    //Show the error.
                    $('.w-upload-form .wrapper-errors').removeClass("hidden");
                    $('.w-upload-form .textError').removeClass("visible");
                    $('.w-upload-form .size-error').addClass("visible");
                    $('.w-upload-form .wrapper-drop').addClass("hidden");
                    $('.w-upload-form').addClass("height-sm");
                    ACC.colorbox.open("", {
                        href: "#upload-form",
                        inline: true,
                        width: "500px",
                        height: "400px",
                        className: "popup-upload",
                        onComplete: function () {},
                        onClosed: function () {
                            $("#upload-form").load(location.href + " .form-upload-file-cart");
                        }
                    });
                } else {
                    $('.w-upload-form .wrapper-errors').addClass("hidden");
                    $('.w-upload-form .textError').removeClass("visible");
                    $('.w-upload-form .wrapper-drop').addClass("hidden");
                    $('.w-upload-form').removeClass("height-sm").addClass("clean-popup");
                    ACC.colorbox.open("", {
                        href: "#upload-form",
                        inline: true,
                        width: "500px",
                        height: "100px",
                        closeButton: false,
                        escKey: false,
				        overlayClose: false,
                        className: "popup-upload single-loading",
                        onComplete: function () {},
                        onClosed: function () {
                            $("#upload-form").load(location.href + " .form-upload-file-cart");
                        }
                    });
                    
                    var fileName = $(this).val().split('\\').pop();
                    $textContainer.text(fileName);
                    // $('.form-upload-file').submit(false);
                    // $('.form-upload-file').submit(function(e) {
                    //     e.preventDefault();
                    // })
                    ACC.uploadcart.triggerProgress();
                    
                }
            } 
                
        });
    },

    changeForm: function () {
        var $fileInput = $('#upload-form .file-input');
        var $droparea = $('#upload-form .file-drop-area');

        // highlight drag area
        $fileInput.on('dragenter focus click', function() {
            $droparea.addClass('is-active');
        });

        // back to normal state
        $fileInput.on('dragleave blur drop', function() {
            $droparea.removeClass('is-active');
        });

        // change inner text
        $fileInput.on('change', function() {
            $.colorbox.resize({height:"400px"});
            $('#upload-form .wrapper-errors').addClass("hidden");
            $('#upload-form .file-drop-area').removeClass("hidden");
            $('#upload-form .textError').removeClass("visible");
            var $fileval = $fileInput.val();
            var filesCount = $(this)[0].files.length;
            var $textContainer = $(this).prev();
            var maxSizeMb = 1;

            var allowedExtensions = /(\.csv|\.xls|\.xlsx)$/i;
            console.log(allowedExtensions, !allowedExtensions.exec($(this)[0].files[0]))
            //check selected file type
            if (!allowedExtensions.exec($(this)[0].files[0])) {
                $('#upload-form .wrapper-errors').removeClass("hidden");
                $('#upload-form .textError').removeClass("visible");
                $('#upload-form .format-error').addClass("visible");
                $.colorbox.resize();
            }

            if (filesCount == 1) {
                // if single file is selected, show file name
                // Allowing file type
                var fileSelected = $(this)[0].files[0];
                //Get the size of the input file.
                var totalSize = fileSelected.size;

                //Convert bytes into MB.
                var totalSizeMb = totalSize  / Math.pow(1024,2);
                if (!allowedExtensions.exec($fileval)) {
                    $('#upload-form .wrapper-errors').removeClass("hidden");
                    $('#upload-form .textError').removeClass("visible");
                    $('#upload-form .format-error').addClass("visible");
                    $fileInput.val("");
                    //$.colorbox.resize({height:"460px"});
                    return false;
                } else if (totalSizeMb > maxSizeMb){ 
                    //Create an error message to show to the user.
                    // var errorMsg = 'File too large. Maximum file size is ' + maxSizeMb + 'MB. Selected file is ' + totalSizeMb.toFixed(2) + 'MB';
                    $fileInput.val("");
                    //Show the error.
                    $('#upload-form .wrapper-errors').removeClass("hidden");
                    $('#upload-form .textError').removeClass("visible");
                    $('#upload-form .size-error').addClass("visible");
                   // $.colorbox.resize({height:"460px"});

                    
                } else {
                    $('#upload-form .wrapper-errors').addClass("hidden");
                    $('#upload-form .textError').removeClass("visible");
                    $.colorbox.resize({height:"420px"});
                    var fileName = $(this).val().split('\\').pop();
                    $textContainer.text(fileName);
                    // $('.form-upload-file').submit(false);
                    // $('.form-upload-file').submit(function(e) {
                    //     e.preventDefault();
                    // })
                    ACC.uploadcart.triggerProgress();
                    $.colorbox.resize({height:"460px", overflow: "auto"});
                }
            } 
        });
    },

    popupUpload: function (type) {
        ACC.colorbox.open("", {
            href: "#upload-form",
            inline: true,
            width: "500px",
            height: "400px",
            className: "popup-upload",
            onComplete: function () {
                ACC.uploadcart.changeForm();
                $(".js-type-effect").val(type);
                $.colorbox.resize();
            },
            onClosed: function () {
                var $fileInput = $('.w-upload-form .file-input');
                $fileInput.val("");
                $(".w-upload-form .file-drop-area").load(location.href + " .w-upload-form .file-drop-area-content");
                $(".w-upload-form .progress").hide();
                $('.w-upload-form .percent-text').text("");
                $(".w-upload-form .wrapper-errors").load(location.href + " .w-upload-form .wrapper-errors");
                $(".w-upload-form .upload-submit").addClass("hidden");
            }
        });
    },

    triggerProgress : function () {
        var selectedFile = document.getElementsByName('csvFile')[0].files[0];
        var form = document.getElementById('importCSVSavedCartForm');
        var formData = new window.FormData(form);
        formData.append("csvFile", selectedFile);
        var urlActionValidate = $('.form-upload-file-cart').attr('data-validate');
        $.ajax({
            type: "POST",
            url: urlActionValidate,
            data: formData,
            processData: false,
            contentType: false,
            success: function (file) {
                
                if ($(window).width() < 640){
                    setTimeout(function () {
                        $(".w-upload-form .upload-submit").click();
                    }, 2000);
                }else {
                    setTimeout(function () {
                        // $(".progress").hide();
                        $(".w-upload-form .upload-submit").removeClass("hidden");
                    }, 1500);
                }
            },
            error: function (e) {
                console.log("ERROR : ", e);
            },
            xhr: function () {
                var fileXhr = $.ajaxSettings.xhr();
                if (fileXhr.upload) {
                    $(".progress").show();
                    fileXhr.upload.addEventListener("progress", function (e) {
                        if (e.lengthComputable) {
                            var percentage = Math.ceil(((e.loaded / e.total) * 100));
                            var textEnding = $('.end-of-progress').text();
                            $('.percent-text').text(percentage + '% loading');
                            $('.progress-bar .loading-animate').css("width",percentage + '%');
                            if (percentage == 100) {
                                $('.percent-text').text(textEnding);
                            }
                        }
                    }, false);
                }
                return fileXhr;
            }
        });
    },

    uploadForm : function () {
        var selectedFile = document.getElementsByName('csvFile')[0].files[0];
        var form = $('.form-upload-file-cart')[0];
        var formData = new window.FormData(form);
        formData.append("csvFile", selectedFile);
        var urlAction = $('.form-upload-file-cart').attr('action');

       let _catalogModal = $('.w-upload-catalogue').closest('#colorbox'),
            _waitingMessageModal = this.loaderModalWithMessage(ACC.configUploadWaitingMessage);
       $('#wait-place-holder').html(_waitingMessageModal);


       $.ajax({
            type: "POST",
            url: urlAction,
            data: formData,
            processData: false,
            contentType: false,
            beforeSend: function(){
                $('#wait-place-holder').show();
                $('.popup-upload').hide()
            },
            success: function (file) {
                window.location.reload();
            },
            error: function (e) {

                $('.popup-upload').show()
                $('#wait-place-holder').hide();

                $(".w-upload-form .upload-submit").addClass("hidden");
                var $fileInput = $('.w-upload-form .file-input');

                if (e.responseJSON) {
                    if ($(window).width() < 640){
                        //Show the error.
                        $fileInput.val("");
                        $(".w-upload-form .file-drop-area").load(location.href + " .w-upload-form .file-drop-area-content");
                        //Show the error.
                        $.each(e.responseJSON, function(i, f) {
                            $('#upload-form .list-errors').append("<li class='textError'>- "+f+"</li>");
                        });
                        $('#upload-form .wrapper-errors').removeClass("hidden");
                        $('#upload-form .list-errors').removeClass("hidden");
                        $('#upload-form .textError').addClass("visible");
                        $('#upload-form .format-error').removeClass("visible");
                        $('#upload-form .size-error').removeClass("visible");
                        $('.w-upload-form').addClass("height-sm");
                        ACC.colorbox.open("", {
                            href: "#upload-form",
                            inline: true,
                            width: "500px",
                            height: "400px",
                            className: "popup-upload-errors",
                            onComplete: function () {},
                            onClosed: function () {
                                window.location.reload();
                            }
                        });
                    }else {
                        
                        $(".w-upload-form .file-msg").load(location.href + " .w-upload-form .file-msg");
                        $fileInput.val("");
                        $(".w-upload-form .progress").hide();
                        $('.w-upload-form .percent-text').text("");
                        // hide all errors
                        $('#upload-form .textError.newOne').remove();

                        //Show the error.
                        $.each(e.responseJSON, function(i, f) {
                            $('#upload-form .list-errors').append("<li class='textError newOne'>- "+f+"</li>");
                        });
                        $('#upload-form .wrapper-errors').removeClass("hidden");
                        $('#upload-form .list-errors').removeClass("hidden");
                        $('#upload-form .textError').addClass("visible");
                        $('#upload-form .format-error').removeClass("visible");
                        $('#upload-form .size-error').removeClass("visible");
                        $.colorbox.resize({height:"460px", overflow:'auto'});
                    }
                }
                setTimeout(function() {
                    $(".w-upload-form .upload-submit").removeAttr("disabled");
                }, 5000);
            }
        });
    },

    loaderModalWithMessage: function (msg) {
        return `<div class="wait-place-order"> ${msg}<div class="loader"></div></div>`;
    }

}